import script from "./newContract.vue?vue&type=script&setup=true&lang=js"
export * from "./newContract.vue?vue&type=script&setup=true&lang=js"

import "./newContract.vue?vue&type=style&index=0&id=63600ab2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63600ab2"]])

export default __exports__